module.exports = __webpack_public_path__ + "img/client3.c7fa6690.png";